// src/pages/dashboardadmindata/expand/brandrecipeexpand.jsx
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector }            from "react-redux";
import Chart                                   from "chart.js/auto";
import Modal                                   from "react-bootstrap/Modal";
import { Card, CardBody }                      from "../../../components/card/card.jsx";
import { fetchAdminBrandAdditionalData }       from "../../../actions/dashboardadmin_actions";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-buttons/js/buttons.colVis.min.js");
require("datatables.net-buttons/js/buttons.html5.min.js");
require("datatables.net-buttons/js/buttons.print.min.js");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

const BrandRecipeExpand = React.memo(({
  data, labels, values, themeColor, themeColorRgb, bodyBg
}) => {
  const dispatch    = useDispatch();
  const chartRef    = useRef(null);
  const summaryRef  = useRef(null);
  const modalRef    = useRef(null);

  const [show, setShow]           = useState(false);
  const [dateLabel, setDateLabel] = useState("");

  // Redux slice for brand‐additional data
  const {
    brandAdditionalData,
    loadingBrandAdditionalData,
    brandAdditionalDataError
  } = useSelector(state => ({
    brandAdditionalData:        state.dashboardadmin.brandAdditionalData,
    loadingBrandAdditionalData: state.dashboardadmin.loadingBrandAdditionalData,
    brandAdditionalDataError:   state.dashboardadmin.brandAdditionalDataError
  }));

  // 1) Chart Over Time
  useEffect(() => {
    if (!chartRef.current) return;
    const chart = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [{
          label:               "Brands Over Time",
          data:                values,
          borderColor:         themeColor,
          backgroundColor:     themeColorRgb,
          pointBackgroundColor: bodyBg,
          borderWidth:         1.5,
          fill:                false,
          pointRadius:         4
        }]
      },
      options: { responsive: true, maintainAspectRatio: false }
    });
    return () => chart.destroy();
  }, [labels, values, themeColor, themeColorRgb, bodyBg]);

  // 2) Summary table with “View” buttons
  useEffect(() => {
    if (!summaryRef.current) return;
    const dt = $(summaryRef.current).DataTable({
      data: [...(data?.dateswise || [])].reverse(),
      columns: [
        {
          title: "#",
          data:  null,
          render: (_d, _t, _r, meta) => meta.row + 1
        },
        { title: "Date",  data: "label" },
        { title: "Count", data: "value" },
        {
          title: "Details",
          data:  null,
          render: (_d, _t, row) =>
            `<button class="btn btn-primary btn-sm view-details"
                     data-row='${JSON.stringify(row)}'>
               View
             </button>`
        }
      ],
      destroy:    true,
      responsive: true
    });

    $(summaryRef.current)
      .off("click", ".view-details")
      .on("click", ".view-details", function() {
        const rowData = $(this).data("row");
        const [, startTime, endTime] = rowData.Details
          .match(/\(([^,]+),([^,]+),([^)]+)\)/).slice(1);

        setDateLabel(rowData.label);
        dispatch(fetchAdminBrandAdditionalData(
          Number(startTime),
          Number(endTime)
        ));
        setShow(true);
      });

    return () => dt.destroy();
  }, [data, dispatch]);

  // 3) Modal table for brandAdditionalData
  useEffect(() => {
    if (!modalRef.current) return;
    const dt = $(modalRef.current).DataTable({
      data: brandAdditionalData || [],
      columns: [
        { title: "ID",         data: "id" },
        { title: "Brand Name", data: "brandName" }, // use actual field
        {
          title: "Created",
          data:  "created",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:  "2-digit",
              day:    "2-digit",
              year:   "numeric",
              hour:   "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            });
          }
        },
        {
          title: "Updated",
          data:  "updated",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:  "2-digit",
              day:    "2-digit",
              year:   "numeric",
              hour:   "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            });
          }
        }
      ],
      destroy:    true,
      responsive: true,
      rowId:      "id"
    });
    return () => dt.destroy();
  }, [brandAdditionalData]);

  return (
    <>
      <h1>Brands</h1>

      {/* Chart Over Time */}
      <section className="accordion mb-3" id="accordionChart">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#chartSection">
              Chart Over Time
            </button>
          </h2>
          <div id="chartSection" className="accordion-collapse collapse show">
            <div className="accordion-body" style={{ height: '400px', overflow: 'hidden' }}>
              <canvas ref={chartRef} className="w-100" height="450" />
            </div>
          </div>
        </div>
      </section>

      {/* Details Over Time */}
      <section className="accordion mb-3" id="accordionTable">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#tableSection">
              Details Over Time
            </button>
          </h2>
          <div id="tableSection" className="accordion-collapse collapse show">
            <div className="accordion-body">
              <div className="table-responsive">
                <table ref={summaryRef} className="table table-striped w-100" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      <Modal show={show} fullscreen onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Brands – {dateLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card>
            <CardBody>
              {loadingBrandAdditionalData && <div className="spinner-border" />}
              {brandAdditionalDataError && (
                <div className="text-danger">{brandAdditionalDataError}</div>
              )}
              {!loadingBrandAdditionalData && !brandAdditionalDataError && (
                <div className="table-responsive">
                  <table ref={modalRef} className="table table-striped w-100" />
                </div>
              )}
            </CardBody>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  );
});

export default BrandRecipeExpand;
